import classNames from 'classnames';
import { DropdownIndicatorProps, components } from 'react-select';
import Icon, { IconNames } from 'components/Icon';
import colors from 'constants/colors';

export const ReportDropdownIndicator = (props: DropdownIndicatorProps) => {
  const isOpen = props.selectProps.menuIsOpen;
  return (
    <components.DropdownIndicator {...props}>
      <div className={classNames('select-toggle-icon', { open: isOpen })}>
        <Icon
          name={isOpen ? IconNames.ChevronUp : IconNames.ChevronDown}
          color={colors.white}
          size={10}
        />
      </div>
    </components.DropdownIndicator>
  );
};

export const reportDropdownIndicatorStyles = {
  dropdownIndicator: (provided: object) => ({
    ...provided,
    display: 'flex',
    alignItems: 'center',
    padding: 0,
  }),
  indicatorsContainer: (provided: object) => ({
    ...provided,
    alignItems: 'center',
    boxSizing: 'border-box' as const,
    display: 'flex',
    flexShrink: 0,
  }),
  indicatorSeparator: () => ({ display: 'none' }),
};
